module.exports = __webpack_public_path__ + "static/media/getupstandup.c6cf94a8.mp3";